import { createContext } from 'react';

export interface StandardCalculatorInputs {
    initialInvestment: number | undefined;
    monthlyContribution: number | undefined;
    savingPeriodYears: number | undefined;
}

export interface StandardInputsContextType {
    calcInputs: StandardCalculatorInputs;
    compareWithSavingsAccount: boolean;
    setCalcInputs: (inputs: StandardCalculatorInputs) => void;
    setCompareWithSavingsAccount: (compare: boolean) => void;
}

export const initialStandardInputsContext: StandardInputsContextType = {
    calcInputs: {
        initialInvestment: 100_000,
        monthlyContribution: 1500,
        savingPeriodYears: 10,
    },
    compareWithSavingsAccount: true,
    setCalcInputs: () => {},
    setCompareWithSavingsAccount: () => {},
};

// Can set input context based on type if needed in the future
// Default to standard
export const InputsContext = createContext<StandardInputsContextType>(initialStandardInputsContext);
